import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";

export default function Separator({
  className,
  decorative = true,
  orientation = "horizontal",
  label,
  ...props
}: ComponentProps<typeof SeparatorPrimitive.Root> & {
  color?: "border" | "foreground";
  label?: string;
}) {
  if (label && orientation === "horizontal") {
    return (
      <div className={cn("flex w-full items-center gap-6", className)}>
        <SeparatorPrimitive.Root
          data-slot="separator"
          decorative={decorative}
          orientation={orientation}
          className="bg-border h-px w-full flex-1 shrink-0"
          {...props}
        />
        <span className="text-foreground-pressed text-xs leading-none">
          {label}
        </span>
        <SeparatorPrimitive.Root
          data-slot="separator"
          decorative={decorative}
          orientation={orientation}
          className="bg-border h-px w-full flex-1 shrink-0"
          {...props}
        />
      </div>
    );
  }

  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      className={cn(
        "bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        className,
      )}
      {...props}
    />
  );
}
